import {
  patientForgotPasswordActions,
  patientResetPasswordActions
} from '../../../../actions/user/patient/auth/forgot_password';

const initialState = {
  isLoading: false,
  error: null,
  successMessage: '',
  patient: null // Can be used to store patient info, if required
};

const patientPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    // Forgot Password Actions
    case patientForgotPasswordActions.FORGOT_PASSWORD.REQUEST:
    case patientResetPasswordActions.RESET_PASSWORD.REQUEST:
      return { ...state, isLoading: true, error: null };

    case patientForgotPasswordActions.FORGOT_PASSWORD.SUCCESS:
      return { ...state, isLoading: false, successMessage: action.payload };

    case patientResetPasswordActions.RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        isLoading: false,
        successMessage: action.payload,
        patient: action.patient || null // Optionally store patient data after reset if provided
      };

    case patientForgotPasswordActions.FORGOT_PASSWORD.FAILURE:
    case patientResetPasswordActions.RESET_PASSWORD.FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case patientForgotPasswordActions.FORGOT_PASSWORD.RESET:
    case patientResetPasswordActions.RESET_PASSWORD.RESET:
      return { ...state, isLoading: false, successMessage: '', error: null };

    default:
      return state;
  }
};

export default patientPasswordReducer;
